import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Juan', 'María', 'Carlos', 'Ana', 'Pedro', 'Laura', 'Diego', 'Valentina', 'Martín', 'Sofía', 'Lucas', 'Camila', 'Nicolás', 'Florencia', 'Matías', 'Agustina'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'San Juan', 'Bahía Blanca', 'Resistencia', 'Posadas'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval(): number {
  return Math.floor(Math.random() * (15000 - 8000 + 1)) + 8000;
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      setNotification({
        name: getRandomItem(names),
        city: getRandomItem(cities)
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 5000);
    let intervalId: NodeJS.Timeout;
    const scheduleNext = () => {
      intervalId = setTimeout(() => {
        showNotification();
        scheduleNext();
      }, getRandomInterval());
    };
    setTimeout(() => {
      scheduleNext();
    }, 9000);
    return () => {
      clearTimeout(initialDelay);
      clearTimeout(intervalId);
    };
  }, []);
  return <AnimatePresence data-id="element-146">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-w-xs" data-id="element-147">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 cursor-pointer" aria-label="Cerrar" data-id="element-148">
            <XIcon className="w-4 h-4" data-id="element-149" />
          </button>
          <div className="flex items-start gap-3 pr-4" data-id="element-150">
            <CheckCircleIcon className="w-8 h-8 text-[#22C55E] flex-shrink-0" data-id="element-151" />
            <div data-id="element-152">
              <p className="text-sm font-semibold text-[#1A1A2E]" data-id="element-153">
                {notification.name} de {notification.city}
              </p>
              <p className="text-xs text-[#4A4A5A]" data-id="element-154">
                compró el MegaPack Inglés en Acción
              </p>
              <p className="text-xs text-[#22C55E] mt-1" data-id="element-155">Hace unos momentos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}